/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyMonitoredObjectOperationalCost,
    ReadOnlyMonitoredObjectOperationalCostFromJSON,
    ReadOnlyMonitoredObjectOperationalCostFromJSONTyped,
    ReadOnlyMonitoredObjectOperationalCostToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20026
 */
export interface InlineResponse20026 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20026
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20026
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20026
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyMonitoredObjectOperationalCost>}
     * @memberof InlineResponse20026
     */
    results: Array<ReadOnlyMonitoredObjectOperationalCost>;
}

export function InlineResponse20026FromJSON(json: any): InlineResponse20026 {
    return InlineResponse20026FromJSONTyped(json, false);
}

export function InlineResponse20026FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20026 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyMonitoredObjectOperationalCostFromJSON)),
    };
}

export function InlineResponse20026ToJSON(value?: InlineResponse20026 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyMonitoredObjectOperationalCostToJSON)),
    };
}


